import { Directive, Input } from '@angular/core';

@Directive({
    selector: '[wdxListGroup]',
    standalone: false,
    host: {
        class: 'list-group',
        '[class.list-group-flush]': 'wdxListGroupFlush',
    },
})
export class ListGroupDirective {
    @Input() wdxListGroupFlush = false;
}
